import { MarketingReferralConstants } from '../../../../shared/marketing_ad_compaign/MarketingReferralConstants.ts';
import { socket } from '../EntryShared.ts';
import { SocketLobbySend } from '../socket/SocketLobbySend.ts';
import { LobbyAction } from '@colonist/lobby-types';
var TabCommunicationEvents = /*#__PURE__*/ function(TabCommunicationEvents) {
    TabCommunicationEvents["RequestSessionReferrer"] = "requestSavedReferrer";
    TabCommunicationEvents["SessionReferrerDataPackage"] = "sendSessionReferrer";
    TabCommunicationEvents["RequestSessionReferralCode"] = "requestSessionReferralCode";
    TabCommunicationEvents["SessionReferralDataPackage"] = "sendSessionReferralCode";
    return TabCommunicationEvents;
}(TabCommunicationEvents || {});
export class UIReferralController {
    static init() {
        this.initVariables();
        // This is a hack to allow tabs to share information between them.
        // The appraoch is documented here: https://medium.com/@marciomariani/sharing-sessionstorage-between-tabs-5b6f42c6348c
        window.addEventListener('storage', (event)=>{
            if (typeof event.key != 'string') return;
            if (event.newValue == null) return;
            switch(event.key){
                case "requestSavedReferrer":
                    this.sendSessionReferrer();
                    break;
                case "sendSessionReferrer":
                    this.updateSessionReferrer(event.newValue);
                    break;
                case "requestSessionReferralCode":
                    this.sendSessionReferralCode();
                    break;
                case "sendSessionReferralCode":
                    this.updateSessionReferralCode(event.newValue);
                    break;
            }
        });
        this.requestSavedReferrerFromOtherOpenTabs();
        this.requestSavedReferralCodeFromOtherOpenTabs();
        socket.controller.registerSessionEstablishedObserver(()=>{
            const referrer = this.referrer;
            const referralCode = this.referralCode;
            const referrerInformation = {
                referrer: referrer == '' ? undefined : referrer,
                referralCode: referralCode !== null && referralCode !== void 0 ? referralCode : undefined
            };
            if (!MarketingReferralConstants.isReferrerInformationEmpty(referrerInformation)) {
                SocketLobbySend.sendLobby(LobbyAction.SaveClientReferrer, referrerInformation);
            }
        });
    }
    static initVariables() {
        const callReferrerToInit = this.referrer;
        const callReferralCodeToInit = this.referralCode;
    }
    static requestSavedReferrerFromOtherOpenTabs() {
        // This is a hack to communitcate between tabs.
        // The other tab is listening for any events where the storage is changed.
        // So by adding/removing an item it acts as a form of communication between tabs.
        // Source: https://medium.com/@marciomariani/sharing-sessionstorage-between-tabs-5b6f42c6348c
        window.localStorage.setItem("requestSavedReferrer", '');
        window.localStorage.removeItem("requestSavedReferrer");
    }
    static sendSessionReferrer() {
        const sessionReferrer = this.getSessionReferrer();
        if (sessionReferrer == null) return;
        // This is a hack to communitcate between tabs.
        // The other tab is listening for any events where the storage is changed.
        // So by adding/removing an item it acts as a form of communication between tabs.
        // Source: https://medium.com/@marciomariani/sharing-sessionstorage-between-tabs-5b6f42c6348c
        window.localStorage.setItem("sendSessionReferrer", sessionReferrer);
        window.localStorage.removeItem("sendSessionReferrer");
    }
    static updateSessionReferrer(referrer) {
        if (referrer == null) return;
        this.referrer = referrer;
    }
    static requestSavedReferralCodeFromOtherOpenTabs() {
        // This is a hack to communitcate between tabs.
        // The other tab is listening for any events where the storage is changed.
        // So by adding/removing an item it acts as a form of communication between tabs.
        // Source: https://medium.com/@marciomariani/sharing-sessionstorage-between-tabs-5b6f42c6348c
        window.localStorage.setItem("requestSessionReferralCode", '');
        window.localStorage.removeItem("requestSessionReferralCode");
    }
    static sendSessionReferralCode() {
        const sessionReferralCode = this.getSessionReferralCode();
        if (sessionReferralCode == null) return;
        // This is a hack to communitcate between tabs.
        // The other tab is listening for any events where the storage is changed.
        // So by adding/removing an item it acts as a form of communication between tabs.
        // Source: https://medium.com/@marciomariani/sharing-sessionstorage-between-tabs-5b6f42c6348c
        window.localStorage.setItem("sendSessionReferralCode", sessionReferralCode);
        window.localStorage.removeItem("sendSessionReferralCode");
    }
    static updateSessionReferralCode(referralCode) {
        if (referralCode == null) return;
        this.referralCode = referralCode;
    }
    static get referrer() {
        const sessionReferrer = this.getSessionReferrer();
        if (sessionReferrer != null) return sessionReferrer;
        const newReferrer = document.referrer;
        this.referrer = newReferrer;
        return newReferrer;
    }
    static set referrer(value) {
        sessionStorage.setItem(this.REFERRER_KEY, value);
    }
    static getSessionReferrer() {
        return sessionStorage.getItem(this.REFERRER_KEY);
    }
    static get referralCode() {
        const sessionReferralCode = this.getSessionReferralCode();
        if (sessionReferralCode != null) return sessionReferralCode;
        const newSessionReferralCode = this.getReferralCodeFromURL();
        if (newSessionReferralCode == null) return null;
        this.referralCode = newSessionReferralCode;
        return newSessionReferralCode;
    }
    static set referralCode(value) {
        if (value == null) return;
        sessionStorage.setItem(this.REFERRAL_CODE_KEY, value);
    }
    static getSessionReferralCode() {
        return sessionStorage.getItem(this.REFERRAL_CODE_KEY);
    }
    static getReferralCodeFromURL() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const referrralCode = urlSearchParams.get(MarketingReferralConstants.marketingReferralCodeURLVariable);
        return referrralCode;
    }
}
UIReferralController.REFERRER_KEY = 'referrer';
UIReferralController.REFERRAL_CODE_KEY = 'referralCode';
